const geosolutions = process.env.NODE_ENV !== "development" ? process.env.REACT_APP_GEOSERVER_OWS: process.env.REACT_APP_GEOSERVER_OWS_LOCAL

export const WFSURL = (typeNames: string, cqlFilter: string) => {
    if(cqlFilter !== ''){
        return `${geosolutions}?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&typeNames=${typeNames}&cql_filter=${cqlFilter}&outputFormat=application/json`
    }
    return `${geosolutions}?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&typeNames=${typeNames}&outputFormat=application/json`
}



export const WFSURLParentId_ = (typeNames: string, parentId: string) =>
    `${geosolutions}?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&typeNames=${typeNames}&CQL_FILTER=Parent='${parentId}'&outputFormat=application/json`;
export const WFSURLParentId = (typeNames: string, parentId: string) =>
    `${geosolutions}?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&typeNames=${typeNames}&CQL_FILTER=parent='${parentId}'&outputFormat=application/json`;
